import { useEffect } from "react";
import { navigate } from "vike/client/router";

export function Page() {
  useEffect(() => {
    // When visiting the bare root path '/', redirect to the default language '/pl'
    // You can also check for a previously selected language in localStorage
    const savedLang = typeof window !== 'undefined' ? localStorage.getItem("language") : null;
    const defaultLang = ["pl", "en", "de"].includes(savedLang || "") ? savedLang : "pl";

    navigate(`/${defaultLang}`);
  }, []);

  // Return a minimal placeholder during the brief redirection
  return null;
}
